import { Card, CardSection } from "tessa/cards";
import { IControlViewModel, ICardUIExtensionContext } from "tessa/ui/cards";
import { DotNetType, createTypedField } from "tessa/platform";
import { GridViewModel, GridRowAction } from "tessa/ui/cards/controls";
import { CdDocStates } from "../CdDocStates";
import {ApprovementRoles, CdGeneralDocumentationClientHelper} from './CdGeneralDocumentationClientHelper';
import { CdRequestForMaterialsSharedHelper } from 'src/cdScripts/Helpers/Cards/CdRequestForMaterialsSharedHelper';
import { CardService, CardRequest } from "tessa/cards/service";
import { CdRequestTypes } from '../../Helpers/CdRequestTypes';
import { showNotEmpty} from "tessa/ui";
import { CdCommonHelper } from 'src/cdScripts/Helpers/CdCommonHelper';
import { CdUIHelper } from '../../../cdScripts/UI/CdUIHelper';
import { CdObjectProjectTypes } from "../Dictionaries/CdObjectProjectTypes";


export class CdRequestForMaterialsClientHelper extends CdGeneralDocumentationClientHelper {
   
 
  public static FillApproversLogic(context: ICardUIExtensionContext) {
    let card: Card = context.model.card;
    let objectsSection: CardSection | undefined = card.sections.tryGet('PkObjectList');
    let pkRdPropertiesSection: CardSection | undefined = card.sections.tryGet('PkRdProperties');
    const objects = context.model.controls.get('Objects') as GridViewModel;
    if (!objectsSection) return;
    objects.rowInitializing.add(e => {
      e.row.fieldChanged.add(async e2 => {
        if (e2.fieldName !== "ObjectID" || !e) return;

        var objectId = e2.fieldValue;
        if (objectId==null) return;
        let isRenovation = false;
        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetRenovationAndProjectType;
        request.info["ObjectID"] = createTypedField(objectId, DotNetType.Guid);
  
        const response = await CardService.instance.request(request);
        await showNotEmpty(response.validationResult.build());
        if (!response.validationResult.isSuccessful) {          
          return;
        }           
        if (response.info.IsRenovation!=null)
          isRenovation = response.info.IsRenovation.$value;

        let projectTypeExtID = -1; 
        if (response.info.ObjectProjectTypeExtID) projectTypeExtID = response.info.ObjectProjectTypeExtID.$value;
        console.debug("projectTypeExtID = " + projectTypeExtID);
        if (pkRdPropertiesSection)
        {
          pkRdPropertiesSection.fields.set("isRenovation", response.info.IsRenovation)
          if (response.info.ObjectProjectTypeID) pkRdPropertiesSection.fields.set("ObjectProjectTypeID", response.info.ObjectProjectTypeID)
          if (response.info.ObjectProjectTypeName) pkRdPropertiesSection.fields.set("ObjectProjectTypeName", response.info.ObjectProjectTypeName)
          if (response.info.ObjectProjectTypeExtID) pkRdPropertiesSection.fields.set("ObjectProjectTypeExtID", response.info.ObjectProjectTypeExtID);
        }
        CdGeneralDocumentationClientHelper.FillApprovers(card, (ar)=>{       
          CdRequestForMaterialsClientHelper.RemoveRole(ar, isRenovation == true ? CdRequestForMaterialsSharedHelper.ApprovementRoles.DirectorCommercialID.toLowerCase()
          : CdRequestForMaterialsSharedHelper.ApprovementRoles.DirectorRenovationID.toLowerCase());          
          CdRequestForMaterialsClientHelper.RemoveRole(ar, (projectTypeExtID === CdObjectProjectTypes.CityBudgetObjects || projectTypeExtID === CdObjectProjectTypes.BudgetSKBObjects) ? CdRequestForMaterialsSharedHelper.ApprovementRoles.PTOManagerID.toLowerCase()
          : CdRequestForMaterialsSharedHelper.ApprovementRoles.PTOManagerSKBID.toLowerCase());    
        });
      });
    });
  }  

  private static RemoveRole(ar: ApprovementRoles[], roleToRemove: string) {    
    const index = ar.findIndex(x => x.RoleID == roleToRemove);
    if (index > -1) {
      ar.splice(index, 1);
    }
  }

  public static async TableMaterialsInitialize(context: ICardUIExtensionContext) {
    let requestForMaterialsItemsTable = CdUIHelper.GetUIControl<GridViewModel>(context, "RequestForMaterialsItems");
    let requestForMaterialsSuppliesTable = CdUIHelper.GetUIControl<GridViewModel>(context, "RequestForMaterialsSupplies");
    if (!requestForMaterialsItemsTable || !requestForMaterialsSuppliesTable) return;
    CdRequestForMaterialsClientHelper.OrderPlus1ForTable(requestForMaterialsItemsTable);
    CdRequestForMaterialsClientHelper.OrderPlus1ForTable(requestForMaterialsSuppliesTable);
  }

  private static OrderPlus1ForTable(table: any) {
    table.rowInitializing.add(async (e) => {
      if (e.action == GridRowAction.Opening || e.action == GridRowAction.Inserted) {
        if (e.action == GridRowAction.Inserted) {
          if (e.row.getField("Number") != null && ((e.row.getField("Number")!.$value as number) == 0 || table!.rows.map(x => x.row.getField("Number")).some(x => (x!.$value as number) === (e.row.getField("Number")!.$value as number)))) {
            let maxOrder = Math.max.apply(null, table!.rows.map(x => x.row.getField("Number")!.$value));
            CdCommonHelper.SetFieldToRow(e.row, "Number", createTypedField(maxOrder + 1, DotNetType.Int32));
          }
        }
      }
    });
  }

  public static TableOrderLogic(card: Card, context: ICardUIExtensionContext) {   
    let edmSection = card.sections.tryGet('PkApprovementMatching');

    let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
    if (pdciSection) {
      let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
      if (edmSection &&
          stateID &&
          (stateID === CdDocStates.Draft.id ||
          stateID === CdDocStates.Rework.id)) {        

        let matchingControlViewModel: IControlViewModel | undefined = context.model.controls.get('Matching');
        if (matchingControlViewModel) {
          let controlViewModel = matchingControlViewModel as GridViewModel | null;
          if (controlViewModel) {
            
            //кнопки добавить\удалить.
            controlViewModel.rowInvoked.add(e => {
              if (e.action === GridRowAction.Deleting)
              { 
                e.cancel = true;
                  controlViewModel!.rows.forEach(row => {
                    let order = row.row.tryGetField("Order")!.$value;
                    let eorder = e.row.tryGetField("Order")!.$value;
                    if (order && row.rowId != e.row.rowId && order>=eorder)
                      row.row.set("Order",createTypedField(order+1, DotNetType.Int32))
                  });           
              }
              if (e.action === GridRowAction.Inserted){                  
                e.cancel = true;                            
              }
            });              
          }
        }
      }
    } 
  }
}